import { zipInput } from '@cred/react-form-field'
import emitOnBlur from '@cred/react-analytics/hoc/emitOnBlur'

const zipInputWithAnalytics = emitOnBlur(zipInput)

export default zipInputWithAnalytics
